import React from "react";
import { Link } from "react-router-dom";
import { IsEmpty } from "../../../util/commonFunctions";

const ErrorPage = props => (
  <div
    className={
      !IsEmpty(props.class)
        ? "d-flex align-items-center text-center " + props.class
        : "d-flex align-items-center text-center"
    }
  >
    <div className="container-error">
      <img src={props.imageUrl} className="img-fluid" alt="error-page" />
      {props.errorPageHeading && (
        <h3 className="title-error">{props.errorPageHeading}</h3>
      )}
      {props.errorCode && <span className="code-error">{props.errorCode}</span>}
      {props.errorPageDescription && (
        <p>
          {props.errorPageDescription}
          {props.email && (
            <a href="support@ausbiz.com.au" target="_top">
              &nbsp;support@ausbiz.com.au
            </a>
          )}
          {props.paraUrl && (
            <Link to={props.paraUrl}>&nbsp;{props.paraUrlText}</Link>
          )}
        </p>
      )}
      {!IsEmpty(props.linkUrl) && (
        <Link to={props.linkUrl}>{props.linkText}</Link>
      )}
    </div>
  </div>
);

export default ErrorPage;
